@if (model()) {
  <app-employee-form [employee]="model()!" (formGroupOutput)="formGroup = $event" />

  @if(formGroup) {
    <div class="d-flex justify-content-end align-items-center mt-4">
      <app-mdb-button (onClick)="submit()"
                      [text]="'SAVE'"
                      [iconClass]="'fas fa-save'"
                      [loading]="loading"/>
    </div>
  }
}

@if (!model()) {
  <app-spinner />
}
